import React, { useContext } from "react";
import classnames from "classnames";
import firebase from "../config/firebase";
import { AuthContext } from "../Contexts/AuthContext";

export default function Signup(props) {
  const { setAuth } = useContext(AuthContext);

  let loginWithFacebook = () => {
    var provider = new firebase.auth.FacebookAuthProvider();
    provider.setCustomParameters({
      display: "popup",
    });
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        var user = result.user;
        if (user) {
          let info = {
            id: user.uid,
            email: user.email,
            name: user.displayName,
            photo: user.photoURL,
          };
          setAuth(JSON.stringify(info));
          props.setShowForm((val) => !val);
        }
      })
      .catch(function (error) {
        if (error.code === "auth/account-exists-with-different-credential") {
          var pendingCred = error.credential;
          var newprovider = new firebase.auth.GoogleAuthProvider();
          firebase
            .auth()
            .signInWithPopup(newprovider)
            .then(function (result) {
              var user = result.user;
              if (user) {
                let info = {
                  id: user.uid,
                  email: user.email,
                  name: user.displayName,
                  photo: user.photoURL,
                };
                setAuth(JSON.stringify(info));
                props.setShowForm((val) => !val);
              }
              result.user
                .linkAndRetrieveDataWithCredential(pendingCred)
                .then(function (usercred) {});
            });
        }
      });
  };

  let loginWithGoogle = () => {
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase
      .auth()
      .signInWithPopup(provider)
      .then(function (result) {
        var user = result.user;
        if (user) {
          let info = {
            id: user.uid,
            email: user.email,
            name: user.displayName,
            photo: user.photoURL,
          };
          setAuth(JSON.stringify(info));
          props.setShowForm((val) => !val);
        }
      })
      .catch(function (error) {
        var errorMessage = error.message;
        console.log(errorMessage);
      });
  };

  return (
    <div
      id="authcon"
      className={classnames("authContainer", {
        show: props.show,
      })}
      onClick={(e) => {
        if (e.target.id === "authcon") props.setShowForm((val) => !val);
      }}
    >
      <div className="signup">
        <div className="google" onClick={loginWithGoogle}>
          <img src={require("../Assets/icons/google.svg")} alt="" />
          <span>Continue with Google</span>
        </div>
        <div className="facebook" onClick={loginWithFacebook}>
          <img src={require("../Assets/icons/facebook.svg")} alt="" />
          <span>Continue with Facebook</span>
        </div>
        <span
          style={{
            fontSize: "12px",
            color: "#62646a",
            textAlign: "center",
            marginTop: "0.5rem",
          }}
        >
          By joining I agree with the terms & conditions.
        </span>
      </div>
    </div>
  );
}
